import { useCallback, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { ConsultAgreeItem, QuickConsultInputs } from '@/types';

export interface UseConsultAgreeProps {}

const useConusltAgree = () => {
  const { register, watch, getValues, setValue } =
    useFormContext<QuickConsultInputs>();

  const isAllagreeActive = useMemo(() => {
    return watch('agreement.privacy') === 'Y' &&
      watch('agreement.provide') === 'Y'
      ? 'Y'
      : 'N';

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watch('agreement.privacy'), watch('agreement.provide')]);

  const handleCheckBox = useCallback(
    (name: ConsultAgreeItem['name']) => {
      setValue(name, getValues(name) === 'Y' ? 'N' : 'Y');
    },
    [getValues, setValue],
  );

  const handleAllCheckBox = useCallback(() => {
    setValue('agreement.privacy', isAllagreeActive === 'Y' ? 'N' : 'Y');
    setValue('agreement.provide', isAllagreeActive === 'Y' ? 'N' : 'Y');
  }, [isAllagreeActive, setValue]);

  return {
    isAllagreeActive,
    handleAllCheckBox,
    handleCheckBox,
    register,
    watch,
  };
};

export default useConusltAgree;
